import { createFileRoute, redirect } from '@tanstack/react-router'
import { getPreferredLang } from '@/hooks/useLang'

export const Route = createFileRoute('/pricing')({
  beforeLoad: async () => {
    throw redirect({ to: '/$lang/pricing', params: { lang: await getPreferredLang() }, replace: true })
  },
})
